import type { WashVisit, CheckInVariables } from "./api";
import { requireScope } from "./auth/session";

const setStatus = (list: WashVisit[], serviceId: string, status: WashVisit["status"]): WashVisit[] =>
  list.map((v) => (v.id === serviceId ? { ...v, status } : v));

export const applyStart = (list: WashVisit[], { serviceId }: { serviceId: string }): WashVisit[] =>
  setStatus(list, serviceId, "InProgress");

export const applyReady = (list: WashVisit[], { serviceId }: { serviceId: string }): WashVisit[] =>
  setStatus(list, serviceId, "ReadyForCollection");

export const applyCollect = (list: WashVisit[], { serviceId }: { serviceId: string }): WashVisit[] =>
  list.filter((v) => v.id !== serviceId);

export const applyCancel = (list: WashVisit[], { serviceId }: { serviceId: string }): WashVisit[] =>
  list.filter((v) => v.id !== serviceId);

export const applyCapture = (list: WashVisit[], c: CheckInVariables): WashVisit[] => {
  const attributes = c.attributes ?? {};
  return [
    {
      id: c.clientCommandId,
      siteId: requireScope().siteId,
      status: "Queued",
      registration: (attributes.registration ?? "").toUpperCase(),
      make: attributes.make ?? null,
      model: attributes.model ?? null,
      colour: attributes.colour ?? null,
      size: (attributes.size === "Small" || attributes.size === "Large" || attributes.size === "ExtraLarge"
        ? attributes.size
        : "Medium"),
      serviceName: c.serviceName,
      quotedPrice: Number(c.quotedPrice),
      phoneNumber: c.mobile ?? "",
      queuePosition: 0,
      inferred: false,
      capturedAt: c.occurredAt,
      startedAt: null,
      readyAt: null,
    },
    ...list,
  ];
};

export const applyReorder = (
  list: WashVisit[],
  { moves }: { moves: { serviceId: string; newPosition: number | string; clientCommandId?: string; occurredAt?: string }[] },
): WashVisit[] => {
  const byId = new Map(moves.map((m) => [m.serviceId, Number(m.newPosition)]));
  return [...list]
    .map((v) => (byId.has(v.id) ? { ...v, queuePosition: byId.get(v.id)! } : v))
    .sort((a, b) => a.queuePosition - b.queuePosition || a.capturedAt.localeCompare(b.capturedAt));
};
